"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ArrowUpIcon = void 0;
/* eslint-disable max-len */
var react_1 = __importStar(require("react"));
var Icon_1 = require("./Icon");
exports.ArrowUpIcon = (0, react_1.forwardRef)(function ArrowUpIcon(props, ref) {
    return (react_1.default.createElement(Icon_1.Icon, __assign({ ref: ref, width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
        react_1.default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M16.0899 10.5078C16.2774 10.6955 16.5317 10.8009 16.797 10.801C17.0623 10.8011 17.3167 10.6958 17.5044 10.5083C17.692 10.3208 17.7975 10.0665 17.7976 9.80118C17.7976 9.53591 17.6924 9.28147 17.5049 9.09383L12.7069 4.29483C12.5193 4.10736 12.265 4.00204 11.9999 4.00204C11.7347 4.00204 11.4804 4.10736 11.2929 4.29483L6.49485 9.09383C6.30734 9.28147 6.20205 9.53591 6.20215 9.80118C6.20224 10.0665 6.30771 10.3208 6.49535 10.5083C6.68299 10.6958 6.93743 10.8011 7.2027 10.801C7.46797 10.8009 7.72234 10.6955 7.90985 10.5078L9.32185 9.09483C9.8531 8.5633 10.3227 7.97358 10.7219 7.33683L11.1909 6.58883L11.2369 6.63583L11.0999 7.59483C11.0339 8.06283 10.9999 8.53483 10.9999 9.00883V18.7988C10.9999 19.064 11.1052 19.3184 11.2927 19.5059C11.4803 19.6935 11.7346 19.7988 11.9999 19.7988C12.2651 19.7988 12.5194 19.6935 12.707 19.5059C12.8945 19.3184 12.9999 19.064 12.9999 18.7988V9.00883C12.9999 8.53583 12.9659 8.06283 12.8999 7.59483L12.7619 6.63483L12.8089 6.58883L13.2789 7.33883C13.6789 7.97483 14.1479 8.56383 14.6789 9.09483L16.0899 10.5078Z", fill: "currentColor" })));
});
